import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "ScheduleHeaderContent with_white_bg ofs posRe",
  style: {"margin-top":"30px","padding":"0"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "posAb",
  style: {"top":"2px","right":"5px","z-index":"1"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5 whiteColor`)
}, "ヘッダー画像を追加", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  class: "fs15 kaigyo rad8 mt5",
  style: {"padding":"36px 30px"}
}
const _hoisted_10 = {
  key: 0,
  class: "fs40 fw900 mb20"
}
const _hoisted_11 = {
  key: 1,
  style: {"line-height":"1.6"}
}
const _hoisted_12 = {
  key: 0,
  class: "mt40 qlContent"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "fs16 fw600"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "fl" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 4,
  class: "fw600 markdown",
  style: {"line-height":"1.3"}
}
const _hoisted_28 = {
  key: 2,
  class: "grey"
}
const _hoisted_29 = {
  key: 0,
  class: "",
  style: {"padding":"10px 30px","background":"#3c4b7c","color":"#fff"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "公開期間", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { class: "fs20 arial" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGear = _resolveComponent("IconGear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSP && _ctx.rcm)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          (_ctx.hasImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "w100 posRe ScheduleHeaderImageContent withEditable",
                style: {"display":"block"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addImage && _ctx.addImage(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.rcm.appeal_content.image_url,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                    width: "48",
                    height: "48",
                    class: "pointer rad10",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteImage && _ctx.deleteImage(...args)))
                  }, null, 8, _hoisted_5)
                ])
              ]))
            : (_openBlock(), _createElementBlock("label", {
                key: 1,
                class: _normalizeClass(`ImageIconContent centered pointer posRe w100 blackBg`),
                style: _normalizeStyle({
                    opacity: `0.8`,
                    display: `block`,
                    height: `120px`,
                    lineHeight: `120px`,
                }),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addImage && _ctx.addImage(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/camera_wt.png`),
                  class: "mr10",
                  width: "33",
                  height: "32",
                  style: {"margin-top":"-7px"}
                }, null, 8, _hoisted_6),
                _hoisted_7
              ], 4)),
          _hoisted_8,
          _createElementVNode("div", {
            class: "ScheduleHeaderTextContent withEditable posRe w100",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addHeaderContent && _ctx.addHeaderContent(...args)))
          }, [
            _createVNode(_component_IconGear, {
              width: 28,
              class: "fl pointer posAb ml10 mt10"
            }),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.hasTitle)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.rcm.appeal_content.title), 1))
                : _createCommentVNode("", true),
              (_ctx.hasContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_ctx.rcm?.room?.appeal_content?.content_type == `delta`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", { innerHTML: _ctx.deltaHtml }, null, 8, _hoisted_13),
                          _hoisted_14
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoLink, (text, textindex) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: `${text}${textindex}`
                            }, [
                              (text.match(_ctx.TemplateUtil.buttonRegex) || text.match(_ctx.TemplateUtil.buttonRegexWithOptions))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                    _createElementVNode("button", {
                                      href: `${text.match(_ctx.TemplateUtil.buttonLinkRegex)[0].replace(`(`, ``).split(`)`)[0]}`,
                                      class: _normalizeClass(`w100 pad20 with_shadow hoverResetShadow with_white_bg innerLink fw600 text-left rad2 hoverGrey hoverLgreyBg ${
                                            _ctx.isSP ? `fs18` : `fs20`
                                        }`),
                                      rel: "noopener noreferrer",
                                      style: {}
                                    }, [
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(text.match(_ctx.TemplateUtil.buttonTextRegex)[0].replace(`[`, ``).replace(`]`, ``)), 1),
                                      _createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/roundarrowS.png`),
                                        width: "25",
                                        height: "25",
                                        class: "fr mr7"
                                      }, null, 8, _hoisted_19),
                                      _hoisted_20
                                    ], 10, _hoisted_17)
                                  ]))
                                : (text.match(_ctx.TemplateUtil.regex))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      _createElementVNode("a", {
                                        href: text,
                                        class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                        target: "_blank",
                                        rel: "noopener noreferrer nofollow",
                                        style: {"text-decoration":"underline"}
                                      }, _toDisplayString(text), 11, _hoisted_22)
                                    ]))
                                  : (text.match(_ctx.TemplateUtil.mailRegex))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                        _createElementVNode("a", {
                                          href: `mailto:${text}`,
                                          class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          style: {"text-decoration":"underline"}
                                        }, _toDisplayString(text), 11, _hoisted_24)
                                      ]))
                                    : (
                                        text.match(_ctx.TemplateUtil.telRegex1) ||
                                        text.match(_ctx.TemplateUtil.telRegex2) ||
                                        text.match(_ctx.TemplateUtil.telRegex3)
                                    )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                          _createElementVNode("a", {
                                            href: `tel:${text}`,
                                            class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            style: {"text-decoration":"underline"}
                                          }, _toDisplayString(text), 11, _hoisted_26)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(text), 1))
                            ]))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.hasContent && !_ctx.hasTitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "テキストを追加できます"))
                : _createCommentVNode("", true)
            ]),
            (_ctx.hasOpenPeriod)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["mt10", `${_ctx.isSP ? `fs12` : `fs14`} fw600`])
                  }, [
                    _hoisted_30,
                    _hoisted_31,
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.openPeriod), 1)
                  ], 2),
                  _hoisted_33
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}